<template>
  <div>
  <div class="columns">
    <div class="column is-9">
      <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Test type">
          <b-select
            placeholder="Select the test type"
            expanded
            v-model="formTestType.testType"
            required
          >
            <option
              v-for="testType in testTypes"
              :value="testType"
              :key="testType.name">
              {{ testType.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-6" v-for="testConfig in formTestType.testType.testMethod.testConfig" >
        <div class="field" v-if="testConfig.type==='json'">
          <label class="label">{{ testConfig.name }}</label>
          <v-jsoneditor v-model="formTestType.testTypeConfig[testConfig.key]" :plus="false" height="160px"
                        :options="jsonEditorOptions"/>
          <p class="help" v-if="testConfig.description">{{ testConfig.description }}</p>
        </div>

        <b-field :label="testConfig.name" v-else-if="testConfig.type==='select'" :message="testConfig.description">
          <b-select expanded v-model="formTestType.testTypeConfig[testConfig.key]" :required="testConfig.required">
            <option
              v-for="(value, key) in testConfig.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>

        <b-field :label="testConfig.name" v-else :message="testConfig.description">
          <b-input
            v-model="formTestType.testTypeConfig[testConfig.key]"
            :required="testConfig.required">
          </b-input>
        </b-field>
      </div>
    </div>
    </div>
    <div class="column is-3">
      <b-message :title="'Inherited config'" v-if="formTestType.testType">
        <p v-for="(value, key) in formTestType.testType.testConfig" v-if="value">
          <b>{{getConfigParamName(key)}}</b>: {{ value }}
        </p>
      </b-message>
    </div>



  </div>

    <div>
      <b-message :title="'Example response'" v-if="formTestType.testType.testMethod">
        <pre>
          {{formTestType.testType.testMethod.exampleResponse}}
        </pre>
      </b-message>
    </div>
</div>



</template>

<script>

import VJsoneditor from 'v-jsoneditor'
import TestTypeService from "@/services/TestTypeService";

export default {
  name: 'TestType',
  data () {
    return {
      formTestType: {},
      testTypes: [],
      jsonEditorOptions: {
        mode: 'code',
        search: 'false',
        mainMenuBar: false,
        statusBar: false
      }
    }
  },

  components: {
    VJsoneditor
  },

  created() {
    this.getTestTypes();
    this.formTestType = this.$store.getters['testJob/formTestType'];
  },

  methods: {
    getTestTypes() {
      TestTypeService.getList()
        .then(response => {
          this.testTypes = response.data
        })
    },

    getConfigParamName(key)
    {
      for (let config of this.formTestType.testType.testMethod.testConfig) {
        if (config.key == key) {
          return config.name;
        }
      }

      return  'Undefined'
    }
  }
}
</script>
